export const INITIAL_PAGE = 1

export default class Pagination {
  constructor(limitValue, totalCount, currentPage, totalPages) {
    this.limitValue = parseInt(limitValue, 10) || 0
    this.totalCount = parseInt(totalCount, 10) || 0
    this.currentPage = parseInt(currentPage, 10) || 0
    this.totalPages = parseInt(totalPages, 10) || 0
  }

  get isFirstPage() {
    return this.currentPage === INITIAL_PAGE
  }

  get isLastPage() {
    return this.currentPage >= this.totalPages
  }

  get currentStartCount() {
    if (this.totalCount === 0) {
      return 0
    }

    return parseInt((this.currentPage - 1) * this.limitValue + 1, 10) || 0
  }

  get currentEndCount() {
    if (this.totalCount === 0) {
      return 0
    }

    return parseInt(this.isLastPage ? this.totalCount : this.currentPage * this.limitValue, 10) || 0
  }

  static initializeWithPage(page = null) {
    return new Pagination(null, null, page || INITIAL_PAGE, null)
  }

  static fromJson(json) {
    if (!json) {
      return Pagination.initial()
    }

    return new Pagination(
      json.limit_value,
      json.total_count,
      parseInt(json.current_page, 10) || INITIAL_PAGE,
      json.total_pages
    )
  }

  static fromJsonLowerCased(headers) {
    return new Pagination(
      headers['x-limit-value'],
      headers['x-total-count'],
      headers['x-current-page'],
      headers['x-total-pages']
    )
  }

  updateCurrentPage(page) {
    const newPagination = Object.assign(Object.create(this), this)
    newPagination.currentPage = parseInt(page, 10)
    return newPagination
  }
}
